import { post, put, get, deleteReq } from './api';

export const fetchBookletShared = ({ token }) =>
  get(`/users/shared?token=${token}`);

export const fetchBookletShares = ({ id }) =>
  get(`/admin/booklets/${id}/shares`);

export const createNewShare = ({ share, id }) =>
  post(`/admin/booklets/${id}/shares`, JSON.stringify({ share }), {
    'Content-Type': 'application/json',
  });

export const createNewPersonalShare = ({ share, id }) =>
  post(`/admin/presentations/${id}/shares/`, JSON.stringify({ share }), {
    'Content-Type': 'application/json',
  });

export const editShare = ({ share, id }) =>
  put(`/admin/booklets/${id}/shares/${share.id}`, JSON.stringify({ share }), {
    'Content-Type': 'application/json',
  });

export const deleteShare = ({ bookletId, shareId }) =>
  deleteReq(`/admin/booklets/${bookletId}/shares/${shareId}`, {
    'Content-Type': 'application/json',
  });

export const refreshShare = ({ bookletId, shareId }) =>
  put(`/admin/booklets/${bookletId}/shares/${shareId}/refresh`);

export const refreshPresentationShareToken = ({ id }) =>
  put(`/admin/presentations/${id}/shares/refresh`);



// WEBPACK FOOTER //
// ./src/services/shareApi.js